<dms-control [dmsTraduction]=dmsTraduction >
	<input type="text" class="textbox form-control" tabindex="{{ dmsIndex }}" [value]="dmsValue" >

	{{ dmsIsVisible }}
	{{ dmsIsEditable }}
</dms-control>